import { useEffect, useState } from 'react'

import { fetchFreeTrialId } from '@/utils/freeTrialUtil'

// The id lives in a cookie, so it can only be read once we are on the client.
// Returns `null` until then, which keeps the banner out of the server markup.
function useFreeTrialLink(): string | null {
  const [freeTrialId, setFreeTrialId] = useState<string | null>(null)

  useEffect(() => {
    setFreeTrialId(fetchFreeTrialId())
  }, [])

  return freeTrialId
}

export default useFreeTrialLink
